<template>
  <div class="container">
    <header-cards/>
    <p id="confirmMsg" v-if="confirmationMsg">{{confirmationMsg}}</p>
    <div class="wrapper animated bounceInLeft">
      <sidebar-cards/>
      <card-form></card-form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import HeaderCards from '@/components/organismCards/HeaderCards'
import SidebarCards from '@/components/organismCards/SidebarCards'
import SelectUnit from '@/components/organismCards/SelectUnit'
import CardForm from '@/components/organismCards/CardForm'
import TestForm from '@/components/organismCards/TestForm'

export default {
  data() {
    return {}
  },
  components: {
    HeaderCards,
    SidebarCards,
    SelectUnit,
    CardForm,
    TestForm
  },
  computed: {
    ...mapState(['orgCardKitId', 'confirmationMsg'])
  }
}

</script>

<style lang="css">
*{
  box-sizing: border-box;
}

body{
  background:#fbfdff;
  color:#000812;
  line-height:1.6;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding:1em;
}

.container{
  max-width:1170px;
  margin-left:auto;
  margin-right:auto;
  padding:25px;
}

ul{
  list-style: none;
  margin-left: 10px;
  padding: 10px;
}

li{
  padding-bottom: 10px;
}

ul a{
  color:#000812;
  line-height:2;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding:1em;
}

#msg{
  color: #f47e20;
  text-align: center;
}

#msg02{
  color: #f47e20;
}

#confirmMsg{
  color: #f47e20;
  text-align: center;
}

.shipInfo{
  border: 1px grey solid;
  padding: 10px;
}

#smlTxt{
  text-align: left;
  font-size: 11px;
  color: #f47e20;
}

.brand{
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  padding: 20px 0 25px 0;
}

.brand span{
  color:#c46b6b;
}

.wrapper > *{
  padding: 1em;
}

.company-info{
  border: 1px solid #cecece;
  border-radius: 5px;
  background-color: #fff;
  margin: 0 0 30px 10px;
  padding: 0 0 30px 0;
}

.company-info h3, .company-info ul{
  text-align: left;
}

.company-info h3{
  background-color: #f7f7f7;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: 1px solid #cecece;
  font-size: 20px;
  font-weight: bold;
  margin: 0 0 10px 0;
  padding: 10px 15px 10px 10px;
}

.company-info h4{
  padding: 10px;
  margin: 0 10px 0 10px;
  border-bottom: 1px solid black;
  font-size: 18px;
  font-weight: bold;
}

.company-info p{
  padding: 10px 20px 0 20px;
}

.contact{
  background:#fbfdff;
  border-radius: 5px;
  border:1px solid #cecece;
  margin: 0 0 30px 15px;
  padding: 0 0 30px 0;
}

.contact h3{
  background-color: #f7f7f7;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: 1px solid #cecece;
  font-size: 20px;
  font-weight: bold;
  margin:0;
  padding: 10px 15px 10px 10px;
}

.contact h4{
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  padding: 10px 15px 10px 20px;
}

.contact p{
  font-size: 14px;
  margin: 0;
  padding: 0;
}

/* FORM STYLES */
.contact form{
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap:20px;
  padding: 15px;
}

.contact form label{
  display:block;
}

.contact form p{
  margin:0;
}

.contact form .full{
  grid-column: 1 / 3;
}

.contact form button, .contact form input, .contact form textarea{
  width:100%;
  padding:5px;
  border-radius: 5px;
  border:1px solid #95A1Ad;
}

.contact form button{
  background:#F47E20;
  font-size: 16px;
  font-weight: bold;
  color:#fff;
  border:0;
  text-transform: uppercase;
}

.contact form button:hover,.contact form button:focus{
  background:#92bde7;
  color:#fff;
  outline:0;
  transition: background-color 2s ease-out;
}

/* LARGE SCREENS */
@media(min-width:700px){
  .wrapper{
    display: grid;
    grid-template-columns: 1fr 2fr;
  }

  .company-info h3{
    text-align: left;
  }

  .brand{
    text-align: center;
  }

  .company-info ul{
    text-align: left;
  }
}

</style>
